/* eslint-disable no-use-before-define */
import { Component } from 'react';
import LeadItem from '../../../Domain/LeadItem';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import LeadService from '../../../Services/leadService';

class EditLeadWindowDescription extends Component {
  static titleForCreate = 'Create New Lead';
  static titleForEdit = 'Edit Lead';
  static ComponentName = 'Lead';

  static itemType = LeadItem;
  static serviceFunction = (edited) => LeadService.EditLead(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CompanyName',
          label: 'Company Name*',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 100),
        },
        {
          fieldName: 'FirstName',
          label: 'First Name*',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forRequiredAndMaxLengthField(e, 100),
        },
        {
          fieldName: 'LastName',
          label: 'Last Name*',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forRequiredAndMaxLengthField(e, 100),
        },
        {
          fieldName: 'CallbackDate',
          label: 'Callback Date*',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: EditLeadWindowDescription.forCallbackDateField,
        },
        {
          fieldName: 'OfficeId',
          label: 'Office*',
          className: 'col-12',
          type: InputTypesEnum.OfficeSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'IndustryCode',
          label: 'Industry*',
          className: 'col-12',
          type: InputTypesEnum.IndustryLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'SourceCode',
          label: 'Source*',
          className: 'col-12',
          type: InputTypesEnum.SourceLookupItemSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'SourceName',
          label: 'Source Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EditLeadWindowDescription.valadityCheckerForSourceName,
        },
      ],
    },
    {
      label: 'Company Information',
      fields: [
        {
          fieldName: 'Description',
          label: 'Description',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'StatusCode',
          label: 'Status',
          className: 'col-12',
          type: InputTypesEnum.LeadLookupSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'IsMspartner',
          label: 'MS Partner',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'MspartnerCode',
          label: 'MS Partner',
          className: 'col-12',
          type: InputTypesEnum.MsPartnerSelect,
          validityChecker: EditLeadWindowDescription.validityCheckerMsPartner,
          hide: (item) => item.IsMspartner !== true,
        },
      ],
    },
    {
      label: 'Contact Information',
      fields: [
        {
          fieldName: 'JobTitle',
          label: 'Job Title',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 100),
        },
        {
          fieldName: 'BusinessPhone',
          label: 'Business Phone*',
          className: 'col-12',
          type: InputTypesEnum.BusinessPhone,
          validityChecker: EditLeadWindowDescription.validityCheckerForBusinessPhone,
        },
        {
          fieldName: 'MobilePhone',
          label: 'Mobile Phone',
          className: 'col-12',
          type: InputTypesEnum.PhoneNumber,
          validityChecker: ValidityHelper.forNotRequiredPhoneNumber,
        },
        {
          fieldName: 'Email',
          label: 'Email',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forEmailRequired,
        },
        {
          fieldName: 'VATNumber',
          label: 'Tax Number',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EditLeadWindowDescription.validityCheckerforVatNumber,
        },
      ],
    },
    {
      label: 'Address',
      fields: [
        {
          fieldName: 'AddressName',
          label: 'Address Name',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EditLeadWindowDescription.validityCheckerforAddressName,
        },
        {
          fieldName: 'AddressStreet',
          label: 'Street',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 100),
        },
        {
          fieldName: 'AddressCity',
          label: 'City',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 100),
        },
        {
          fieldName: 'AddressState',
          label: 'State/Province',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 50),
        },
        {
          fieldName: 'AddressPostalCode',
          label: 'Postal',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forMaximizedLengthField(e, 20),
        },
        {
          fieldName: 'AddressCountryId',
          label: 'Country',
          className: 'col-12',
          type: InputTypesEnum.CountrySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    },
    {
      label: 'Source',
      fields: [
        {
          fieldName: 'ReferredBy',
          label: 'Referred By',
          className: 'col-12',
          type: InputTypesEnum.ContactSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AssignedTo',
          label: 'Assigned To',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'WebSiteUrl',
          label: 'Web Url*',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: (e) => ValidityHelper.forRequiredAndMaxLengthField(e, 200),
        },
        {
          fieldName: 'TimeZoneOffset',
          label: 'Time Zone',
          className: 'col-12',
          type: InputTypesEnum.Select,
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: selectHelper.getTimeZoneOptions(),
        },
      ],
    },
    {
      label: 'Details',
      fields: [
        {
          fieldName: 'AllowBulkEmail',
          label: 'Allow Bulk Email?',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowEmail',
          label: 'Allow Email?',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowPhone',
          label: 'Allow Phone?',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowPostalMail',
          label: 'Allow Post Mail?',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AllowSendMedia',
          label: 'Allow Social Media?',
          className: 'col-12',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  static validityCheckerforAddressName(e, editedItem) {
    if (
      (editedItem.AddressStreet !== '' ||
        editedItem.AddressCity !== '' ||
        editedItem.AddressState !== '' ||
        editedItem.AddressPostalCode !== '' ||
        (editedItem.AddressCountryId !== '' && editedItem.AddressCountryId !== null)) &&
      editedItem.AddressName === ''
    )
      return 'Address Name is required to be given to new address.';

    if (ValidityHelper.forMaximizedLengthField(e, 200) !== '') return ValidityHelper.forMaximizedLengthField(e, 200);
    return '';
  }

  static validityCheckerMsPartner(e, editedItem) {
    if (editedItem === undefined) return '';
    if (editedItem.IsMspartner === false) return '';
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    return '';
  }

  static forCallbackDateField(e, editedItem) {
    if (!editedItem.IsActive) return '';
    const selectedDate = new Date(e);
    const today = new Date();
    if (selectedDate <= today) return 'Callback Date should be later than today.';
    return '';
  }

  static validityCheckerforVatNumber(e, editedItem) {
    if (e === '') return '';
    if (e && e.length > 50) return 'Tax Number too long.';
    return ValidityHelper.validityCheckerforVatNumber(e, editedItem);
  }

  static valadityCheckerForSourceName(e, editedItem) {
    if (ValidityHelper.forMaximizedLengthField(e, 100) !== '') return ValidityHelper.forMaximizedLengthField(e, 100);
    if (editedItem.SourceCode && editedItem.SourceCode.toString() === '10') {
      return ValidityHelper.validityCheckerforVatNumber(e, editedItem);
    }
    return '';
  }

  static validityCheckerForBusinessPhone(e, editedItem) {
    if (editedItem.LeadId || e) {
      return ValidityHelper.forRequiredPhoneNumber(e, editedItem);
    }
    return '';
  }
}

export default EditLeadWindowDescription;
